import { PartnerOnboardingItemStatus } from 'src/app/partnerportal/models/partner-onboarding';

export class SelectedIdentification {
    IdentificationType: IdentificationType;
    Value: string;
    Status: PartnerOnboardingItemStatus;
    ConversationId: string;
    
    constructor(source?: Partial<SelectedIdentification>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class IdentificationType {
    Id: number | null;
    Name: string;
  
    constructor(source?: Partial<IdentificationType>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class FormIdentification {
    IdentificationType: IdentificationType;
    IdentificationValue: string;
    Selected: boolean;
    Status: PartnerOnboardingItemStatus;
    ConversationId: string;

    constructor(source?: Partial<FormIdentification>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class FormCustomIdentification {
    IdentificationType: string;
    IdentificationValue: string;
    Status: PartnerOnboardingItemStatus;
    ConversationId: string;

    constructor(source?: Partial<FormCustomIdentification>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}